import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/components-icon/previous.svg';
import _imports_1 from '@/assets/images/components-icon/next.svg';
const _withScopeId = n => (_pushScopeId("data-v-076a5cb2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mask"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "operate"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "operate-line"
}, "|", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Teleport, {
    to: "html"
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "picture",
    onMousewheel: _cache[1] || (_cache[1] = _withModifiers((...args) => $setup.rollImg && $setup.rollImg(...args), ["prevent"]))
  }, [_createElementVNode("img", {
    src: _ctx.url,
    alt: "",
    ref: "image",
    onMousedown: _cache[0] || (_cache[0] = _withModifiers((...args) => $setup.moveImg && $setup.moveImg(...args), ["prevent"]))
  }, null, 40, _hoisted_2)], 32), $props.isMultiple ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "previous",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.perviousPicture && $setup.perviousPicture(...args))
  }, _hoisted_4)) : _createCommentVNode("", true), $props.isMultiple ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "next",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.nextPicture && $setup.nextPicture(...args))
  }, _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "operate-close",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.handleClose && $setup.handleClose(...args))
  }, _toDisplayString(_ctx.$t('transferWarehouse.off')), 1), _hoisted_8, _createElementVNode("div", {
    class: "operate-download",
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.downloadPic && $setup.downloadPic(...args))
  }, _toDisplayString(_ctx.$t('transferWarehouse.download')), 1)])])]);
}